import * as types from '../actions/types.action';

const initialState = {
  uploading: false,
  uploadError: null,
  uploadResult: null,
  invoices: [],
  invoicesLoading: false,
  invoicesError: null,
  page: {page: 0, totalPages: 0, totalElements: 0},
  detail: null,
  detailLoading: false,
  detailError: null,
};

export default function invoiceUploadReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPLOAD_INVOICE_REQUESTED:
      return Object.assign({}, state, {
        uploading: true,
        uploadError: null,
        uploadResult: null,
      });
    case types.UPLOAD_INVOICE_SUCCESS:
      return Object.assign({}, state, {
        uploading: false,
        uploadResult: action.response,
      });
    case types.UPLOAD_INVOICE_FAILED:
      return Object.assign({}, state, {
        uploading: false,
        uploadError: action.error,
      });
    case types.UPLOAD_INVOICE_RESET:
      return Object.assign({}, state, {
        uploading: false,
        uploadError: null,
        uploadResult: null,
      });

    case types.FETCH_UPLOADED_INVOICES_REQUESTED:
      return Object.assign({}, state, {
        invoicesLoading: true,
        invoicesError: null,
      });
    case types.FETCH_UPLOADED_INVOICES_SUCCESS:
      return Object.assign({}, state, {
        invoicesLoading: false,
        invoices: action.data.invoices,
        page: {
          page: action.data.page,
          totalPages: action.data.totalPages,
          totalElements: action.data.totalElements,
        },
      });
    case types.FETCH_UPLOADED_INVOICES_FAILED:
      return Object.assign({}, state, {
        invoicesLoading: false,
        invoicesError: action.error,
      });

    case types.FETCH_UPLOADED_INVOICE_DETAIL_REQUESTED:
      return Object.assign({}, state, {
        detailLoading: true,
        detailError: null,
        detail: null,
      });
    case types.FETCH_UPLOADED_INVOICE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        detailLoading: false,
        detail: action.data,
      });
    case types.FETCH_UPLOADED_INVOICE_DETAIL_FAILED:
      return Object.assign({}, state, {
        detailLoading: false,
        detailError: action.error,
      });

    case types.REMOVE_AUTH_SUCCESS:
      return initialState;

    default:
      return state;
  }
}
